export default (initialState = {}) => {
  return () => {
    return {
      document: {},
      sub_category: "",
      _id: "",
      files: [],
      max_documents: 1,
      user_id: "",
      number_of_cheques: null,
      amount_per_cheque: null,
      ...initialState,
    };
  };
};
